import { createContext } from "react";

const CommonStylesChangesContext = createContext({});

export default CommonStylesChangesContext;
